// The Dashmote staff email domain, anchored with a leading `@` so a look-alike
// domain (e.g. `x@evildashmote.com`) cannot pass an `endsWith` check. Mirrors
// the backend `is_dashmote_staff` domain half and apps/web's `isDashmoteStaffUser`.
export const DASHMOTE_EMAIL_DOMAIN = "@dashmote.com";

/**
 * Whether `email` is a Dashmote staff address.
 *
 * Anchored on the `@` so an unanchored `endsWith("dashmote.com")` — which would
 * also match `x@evildashmote.com` — cannot leak. A missing or non-string email
 * is not staff (fail closed). Case- and whitespace-insensitive, since email
 * addresses are compared case-insensitively and callers pass user-entered input.
 *
 * @param {unknown} email
 * @returns {boolean}
 */
export function isDashmoteStaffEmail(email) {
  return (
    typeof email === "string" &&
    email.trim().toLowerCase().endsWith(DASHMOTE_EMAIL_DOMAIN)
  );
}
